import './src/i18n';

import React from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from './src/i18n';
import CustomCookieConsent from './src/components/CookieConsent';
import { initCookieManager } from './src/utils/cookieManager';

// Inicializar el manejador de cookies lo antes posible
if (typeof window !== 'undefined') {
  initCookieManager();
}

export const wrapRootElement = ({ element }) => (
  <I18nextProvider i18n={i18n}>
    <CustomCookieConsent />
    {element}
  </I18nextProvider>
);

export const onRouteUpdate = ({ location }) => {
  const { hash } = location;

  if (hash) {
    const element = document.getElementById(hash.substring(1));
    if (element) {
      const offset = 85;
      const elementPosition = element.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  }
};